import { $translate } from '@/utils/i18n';
export const proObj = {
    title: $translate('lang.E3202103030008', { defaultText: '成品下线' }),
    list: [{
        span: 8,
        label: $translate('lang.E3202103030020', { defaultText: '产品编号' }),
        value: '',
        key: 'itemCode'
    }, {
        span: 8,
        label: $translate('lang.E3202103030025', { defaultText: '产品型号' }),
        value: '',
        key: 'productType'
    }, {
        span: 8,
        label: $translate('lang.E3202103030026', { defaultText: '生产工单' }),
        value: '',
        key: 'sourceBillNo'
    }, {
        span: 8,
        label: $translate('lang.E3202103030027', { defaultText: '库存组织' }),
        value: '',
        key: 'recOrgName'
    }, {
        span: 8,
        label: $translate('lang.E3202103030028', { defaultText: '下线时间' }),
        value: '',
        key: 'prodDate'
    }, {
        span: 8,
        label: $translate('lang.E3202103030029', { defaultText: '大箱条码' }),
        value: '',
        key: 'barcodeNo'
    }]
};